import { render, staticRenderFns } from "./LeadLovers.vue?vue&type=template&id=38d34a33&"
import script from "./LeadLovers.vue?vue&type=script&lang=js&"
export * from "./LeadLovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports